/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  DeleteTournamentsIdMutationResponse,
  DeleteTournamentsIdPathParams,
} from "../types/DeleteTournamentsId.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteTournamentsIdMutationKey = () =>
  [{ url: "/tournaments/:id" }] as const;

export type DeleteTournamentsIdMutationKey = ReturnType<
  typeof deleteTournamentsIdMutationKey
>;

/**
 * @summary Удалить турнир (только черновик без регистраций) — для организаторов
 * {@link /tournaments/:id}
 */
export async function deleteTournamentsId(
  id: DeleteTournamentsIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteTournamentsIdMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "DELETE", url: `/tournaments/${id}`, ...requestConfig });
  return res;
}

export function deleteTournamentsIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = deleteTournamentsIdMutationKey();
  return mutationOptions<
    ResponseConfig<DeleteTournamentsIdMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteTournamentsIdPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteTournamentsId(id, config);
    },
  });
}

/**
 * @summary Удалить турнир (только черновик без регистраций) — для организаторов
 * {@link /tournaments/:id}
 */
export function useDeleteTournamentsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteTournamentsIdMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: DeleteTournamentsIdPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteTournamentsIdMutationKey();

  const baseOptions = deleteTournamentsIdMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<DeleteTournamentsIdMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteTournamentsIdPathParams["id"] },
    TContext
  >;

  return useMutation<
    ResponseConfig<DeleteTournamentsIdMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteTournamentsIdPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<DeleteTournamentsIdMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: DeleteTournamentsIdPathParams["id"] },
    TContext
  >;
}
